<script setup lang="ts">
import type { Point } from '.';

defineProps<{ point: Point }>();
</script>

<template>
  <div class="gap-r3 flex items-center">
    <AppIcon :name="point.icon" size="md" />
    <AppParagraph>{{ point.text }}</AppParagraph>
  </div>
</template>
